import { useAppContext } from "../../layout/layout";
import {
  Wrapper,
  FrontSide,
  BackSide,
  CompanyName,
  ExperienceInfo,
  Location,
} from "./experience-card.styles";
import { MdLocationCity } from "react-icons/md";
import { motion } from "framer-motion";
import { fadeIn } from "../../utils/motion/motion.utils";
const ExperienceCard = ({
  id,
  en_name,
  de_name,
  en_role,
  de_role,
  setId,
  loc,
  index,
}) => {
  const { lang } = useAppContext();

  return (
    <motion.div
      variants={fadeIn("up", "spring", index * 0.5, 0.75)}
      className="mt-4"
    >
      <Wrapper>
        <FrontSide>
          <h4>{lang === "en" ? en_name : de_name}</h4>
          <Location className="flex justify-start items-center">
            <MdLocationCity className="factory-icon w-6" />
            <p>{loc}</p>
          </Location>
        </FrontSide>
        <BackSide>
          <CompanyName>
            <h3>{en_name.charAt(0).toUpperCase()}</h3>
          </CompanyName>
          <ExperienceInfo>
            <h5>{lang === "en" ? en_role : de_role}</h5>
            <button className="hero-contact-btn btn " onClick={() => setId(id)}>
              DETAILS
            </button>
          </ExperienceInfo>
        </BackSide>
      </Wrapper>
    </motion.div>
  );
};
export default ExperienceCard;
